import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/fromPromise';
import { performPostRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import type { BaseUrl } from '@atlassian/jira-shared-types/src/general.tsx';
import type { Action } from '../../state/actions';

const installChatAppUrl = (baseUrl: BaseUrl) =>
	`${baseUrl}/rest/atlassian-connect/1/systemaddons/install`;

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (baseUrl: BaseUrl, addonKey: string): Observable<Action> =>
	Observable.fromPromise(
		performPostRequest(installChatAppUrl(baseUrl), {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				addonKey,
			}),
		}),
	);
